// extracted by mini-css-extract-plugin
module.exports = {"flex":"Flex_flex__2M-vN","column":"Flex_column__12jDT","inline":"Flex_inline__Gtv-9","start":"Flex_start__2U56Y","wrap":"Flex_wrap__2G9us"};